import { TabModules } from '~/data/company';
import { EmployeeModuleConfig } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/types';

export enum EmployeeModuleTabPath_Development {
  Experience = 'experience',
  Education = 'education',
  Competencies = 'competencies',
  DevelopmentPlan = 'development-plan',
  JobReqEvaluation = 'job-req-evaluation',
}

export enum EmployeeModuleTabConfigKey_Development {
  Competencies = 'DEV_COMPETENCIES',
  Education = 'DEV_EDUCATION',
  Experience = 'DEV_EXPERIENCE',
  JobReqEvaluation = 'DEV_JOB_REQUIREMENT_EVAL',
  DevelopmentPlan = 'DEV_PLAN',
}

export enum EmployeeModuleTabInstructionKey_Development {
  Competencies = 'INSTRUCTIONS_DEV_COMPETENCIES',
  Education = 'INSTRUCTIONS_DEV_EDUCATION',
  Experience = 'INSTRUCTIONS_DEV_EXPERIENCE',
  JobReqEvaluation = 'INSTRUCTIONS_DEV_JOB_REQUIREMENT_EVAL',
  DevelopmentPlan = 'INSTRUCTIONS_DEV_DEVELOPMENT_PLAN',
}

export const EmployeeModuleRouting_Development: EmployeeModuleConfig<
  EmployeeModuleTabPath_Development,
  EmployeeModuleTabConfigKey_Development,
  EmployeeModuleTabInstructionKey_Development
> = {
  path: 'development',
  module: TabModules.DEVELOPMENT,
  defaultTab: EmployeeModuleTabPath_Development.Experience,
  tabConfigs: [
    {
      path: EmployeeModuleTabPath_Development.Experience,
      enabledConfigKey: EmployeeModuleTabConfigKey_Development.Experience,
      instructionKey: EmployeeModuleTabInstructionKey_Development.Experience,
    },
    {
      path: EmployeeModuleTabPath_Development.Education,
      enabledConfigKey: EmployeeModuleTabConfigKey_Development.Education,
      instructionKey: EmployeeModuleTabInstructionKey_Development.Education,
    },
    {
      path: EmployeeModuleTabPath_Development.Competencies,
      enabledConfigKey: EmployeeModuleTabConfigKey_Development.Competencies,
      instructionKey: EmployeeModuleTabInstructionKey_Development.Competencies,
    },
    {
      path: EmployeeModuleTabPath_Development.DevelopmentPlan,
      enabledConfigKey: EmployeeModuleTabConfigKey_Development.DevelopmentPlan,
      instructionKey:
        EmployeeModuleTabInstructionKey_Development.DevelopmentPlan,
    },
    {
      path: EmployeeModuleTabPath_Development.JobReqEvaluation,
      enabledConfigKey: EmployeeModuleTabConfigKey_Development.JobReqEvaluation,
      instructionKey:
        EmployeeModuleTabInstructionKey_Development.JobReqEvaluation,
    },
  ],
};
